import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useNavigate } from "react-router-dom";
import { useCentralStore } from "stores";

export const deleteDenominationReport = ({ reportId, denominationId }) => {
  return axios.delete(`/denominations/${denominationId}/report/${reportId}`);
};

export const useDeleteDenominationReport = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeDeleteModal = useCentralStore.getState().closeDeleteModal;

  const navigate = useNavigate();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["denomination-reports"]);
      queryClient.invalidateQueries(["reports-timeline"]);

      setNotification({
        type: "success",
        message: "Denomination report deleted successfully!"
      });

      closeDeleteModal();
      navigate(-1, { replace: true });
    },
    ...config,
    mutationFn: deleteDenominationReport
  });
};
